import angular from 'angular';
import { BaseController } from '../../../common/base/controller';

export class FinanceBulkImportController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({ controllerService });
  }

  $onInit() {}

  bulkImport() {
    this.bulkImportBusy = true;
    let bulk;

    // Parse imported raw bulk data to json
    try {
      bulk = angular.fromJson(`${this.rawData}`);
    } catch(ex) {
      this.error(ex);
      this.bulkImportBusy = false;
    }

    // Stop here when the parsing failed
    if (!bulk) {
      return;
    }

    this.onImport({items:bulk});
    this.clear();
    this.bulkImportBusy = false;
  }

  clear() {
    this.rawData = null;
  }
}
